import React, { createContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('[AuthContext] useEffect triggered: Checking stored user in localStorage...');
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      console.log('[AuthContext] Found stored user in localStorage, setting user state...');
      setUser(JSON.parse(storedUser));
    } else {
      console.log('[AuthContext] No stored user in localStorage.');
    }
  }, []);

  // Log user state changes
  useEffect(() => {
    console.log('[AuthContext] User state changed:', user);
  }, [user]);
//##################################################
  const login = async (email, password) => {
    try {
      console.log(`[AuthContext] Attempting login for email: ${email}`);
      console.log('[AuthContext] Calling authService.login...');
      const userData = await authService.login(email, password);
      console.log('[AuthContext] Login successful, setting user state...');
      setUser(userData);
      console.log('[AuthContext] User data:', userData);
      localStorage.setItem('user', JSON.stringify(userData));
      console.log('[AuthContext] User data saved to localStorage.');
      console.log('[AuthContext] Navigating to dashboard...');
      navigate('/dashboard');
    } catch (error) {
      console.error('[AuthContext] Login failed:', error);
      // Optional: Consider handling the error more gracefully (e.g., showing a message to the user)
      throw error;
    }
  };

//##################################################
  const logout = () => {
    console.log('[AuthContext] Logging out, clearing user data...');
    console.log('[AuthContext] Current user state before logout:', user);
    console.log('[AuthContext] LocalStorage before logout:', localStorage.getItem('user'));

    setUser(null);
    localStorage.removeItem('user');
    
    console.log('[AuthContext] User data cleared from state and localStorage.');


    console.log('[AuthContext] Navigating to login...');
    navigate('/login');  // Redirect to login page
  };
//##################################################
  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
